import React from 'react'

/**
 * Client-only media query hook using window.matchMedia.
 * - Returns false during SSR/tests; updates on the client only.
 *
 * Example:
 *   import { BREAKPOINTS } from '@classy/campaign-page-blocks'
 *   const isBelowTablet = useMediaQuery(
 *     `(max-width: ${BREAKPOINTS.tablet}px)`,
 *   )
 */

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = React.useState(false)

  React.useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return

    const m = window.matchMedia(query)
    setMatches(m.matches)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    m.addEventListener('change', onChange)

    return () => m.removeEventListener('change', onChange)
  }, [query])
  return matches
}
